
/*
 * ONEPLETE — Desktop Scroll Animations
 * Fade, slide and staggered reveal effects.
 * Desktop only: 990px+
 */

(() => {
  'use strict';

  const media = window.matchMedia(
    '(min-width: 990px) and (prefers-reduced-motion: no-preference)'
  );

  const SELECTORS = [
    // Oneplete product cards
    '.ofc__header',
    '.ofc__card',

    // Oneplete ritual split
    '.ors__media',
    '.ors__eyebrow',
    '.ors__heading',
    '.ors__description',
    '.ors__point',
    '.ors__actions',

    // Custom review section
    '.crv__heading',
    '.crv__subheading',
    '.crv__stat',
    '.crv__gallery-wrap',
    '.crv__footnote',

    // Generic custom-section targets
    '[id^="custom-image-text-"] h2',
    '[id^="custom-image-text-"] .cit__content',
    '[id^="custom-image-text-"] .cit__media',

    // Three steps
    '.oneplete-three-steps .step',
    '.oneplete-three-steps .step-card',
    '.oneplete-three-steps h2',

    // Reusable class for future sections
    '.op-animate'
  ];

  let observer = null;

  function clearAnimations() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    document.querySelectorAll('[data-op-reveal]').forEach(el => {
      el.removeAttribute('data-op-reveal');
      el.removeAttribute('data-op-direction');
      el.style.removeProperty('--op-delay');
    });
  }

  function initAnimations() {
    clearAnimations();

    if (!media.matches) return;

    if (!('IntersectionObserver' in window)) return;

    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        entry.target.setAttribute(
          'data-op-reveal',
          'visible'
        );

        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -4% 0px'
    });

    const targets = document.querySelectorAll(
      SELECTORS.join(',')
    );

    targets.forEach((element, index) => {
      // Avoid interfering with sliders and sticky animations.
      if (element.closest(
        '.swiper, .splide, [data-sticky], .scroll-trigger'
      )) return;

      const rect = element.getBoundingClientRect();

      let direction = 'up';

      if (element.matches(
        '.ors__media, .crv__gallery-wrap'
      )) {
        direction = 'left';
      }

      element.setAttribute(
        'data-op-direction',
        direction
      );

      element.style.setProperty(
        '--op-delay',
        `${(index % 4) * 90}ms`
      );

      // Elements already visible should never disappear.
      if (rect.top < window.innerHeight * 0.9) {
        element.setAttribute(
          'data-op-reveal',
          'visible'
        );
        return;
      }

      element.setAttribute(
        'data-op-reveal',
        'ready'
      );

      observer.observe(element);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAnimations,
      { once: true }
    );
  } else {
    initAnimations();
  }

  media.addEventListener?.(
    'change',
    initAnimations
  );

  // Refresh when sections are modified in Shopify.
  document.addEventListener(
    'shopify:section:load',
    initAnimations
  );

  document.addEventListener(
    'shopify:section:reorder',
    initAnimations
  );

  document.addEventListener(
    'shopify:section:unload',
    clearAnimations
  );

})();
